// Canais nativos cuja criacao de nova conexao foi desativada (#4383).
// Conexoes ja existentes continuam funcionando normalmente — o bloqueio
// vale apenas para o card de "Nova Conexao".
export const DISABLED_NATIVE_CHANNELS = ["whatsapp"];

export const isNativeChannelDisabled = (channel) =>
  DISABLED_NATIVE_CHANNELS.includes(channel);
